import './ErrorBoundary.scss';
import { Alert } from 'antd';
import { NOTIFICATIONS_COPY } from '@sonar-software/sonar-ts-constants';
import React, { PropsWithChildren } from 'react';

interface ErrorBoundaryState {
	error?: Error;
	errorInfo?: React.ErrorInfo;
	hasError: boolean;
}

const messageText = NOTIFICATIONS_COPY.ERROR_UNHANDLED_CONTACT_WITH_MESSAGE;

export class ErrorBoundary extends React.Component<PropsWithChildren, ErrorBoundaryState> {
	constructor(props: Record<string, unknown>) {
		super(props);
		this.state = {
			hasError: false
		};
	}

	public componentDidCatch(error: Error, info: React.ErrorInfo): void {
		this.setState({
			error,
			errorInfo: info,
			hasError: true
		});
	}

	public render(): React.ReactNode {
		if (!this.state.hasError) {
			return this.props.children;
		}

		return (
			<div className='error-boundary'>
				<Alert
					description={
						<div>
							<b>{ messageText }</b>
							<br />
							<p className='error-info'>
								{ this.state.error?.toString() }
								<br />
								{ JSON.stringify(this.state.errorInfo, null, 2).toString() }
							</p>
						</div>
					}
					message={ NOTIFICATIONS_COPY.ERROR_UNHANDLED }
					type='error' />
			</div>
		);
	}
}
